module.exports = __webpack_public_path__ + "8f31cce4c045955bd9093e59558ef9bc.pdf";